export default __webpack_public_path__ + "static/media/mapping_transaform.ba97cb15.svg";